module.exports = __webpack_public_path__ + "img/folder.5a3e9cea.svg";